<template>
    <v-footer padless fixed app>
        <v-card flat tile width="100%">
            <v-card-text
                :class="[
                'py-3 app-bar agreements d-flex justify-center',
                { 'flex-column align-center': $vuetify.breakpoint.xsOnly },
                ]"
            >
                <span v-html="copyright"></span>
            </v-card-text>
        </v-card>
    </v-footer>
</template>

<script>
export default {
    computed: {
        copyright() {
            let today = new Date()
            return '&copy; ConnectPlug Admin ' + today.getFullYear()
        },
    },
};
</script>

<style scoped lang="scss">
%base-font {
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    font-weight: 500;
}

span {
    color: var(--v-white-base);
}
</style>